import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { PagedResult, TaskInstanceDto } from "@gw/shared-types";
import { listTaskInstances, type ListTaskInstancesParams } from "@/api/endpoints";

export function useTaskInstancesQuery(params: ListTaskInstancesParams, enabled = true) {
  return useQuery<PagedResult<TaskInstanceDto>>({
    queryKey: ["tasks", "instances", params],
    queryFn: () => listTaskInstances(params),
    staleTime: 60_000,
    enabled,
    placeholderData: keepPreviousData,
  });
}
